import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-489d9155"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-body" }


interface Props {
  visible: boolean;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    visible: { type: Boolean }
  },
  emits: ['hide'],
  setup(__props: any, { emit }) {

const props = __props as {
  visible: boolean;
}






return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (__props.visible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "modal",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('hide')))
        }, [
          _createElementVNode("div", {
            class: "modal-content",
            onClick: _cache[0] || (_cache[0] = (e) => e.stopPropagation())
          }, [
            _createElementVNode("div", _hoisted_1, [
              _renderSlot(_ctx.$slots, "default")
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})